const userRemove = (state = null, action) => {
    if (action.type === "USER_REMOVE") {
        return action.payload;
    } else {
        return state;
    }
};

export default userRemove;
